import React, { CSSProperties, useEffect, useRef, useState } from 'react';
import {
  Align,
  Arrange,
  IconButton,
  SvgArrowLeftAlt,
  SvgArrowRightAlt,
} from '@loomhq/lens';

import styles from 'components/share-video/edit-tools/styles.module.less';

interface Props {
  disableLeft: boolean;
  disableRight: boolean;
  onMoveLeft: () => void;
  onMoveRight: () => void;
}

const MOVE_LEFT_ALT_TEXT = 'Move clip to the left';
const MOVE_RIGHT_ALT_TEXT = 'Move clip to the right';

const getLeftCenteredPosition = (arrowsContainer: HTMLDivElement): number => {
  // find parent clip editor. If we reach the clipEditorContainer we went too far
  let ancestor: HTMLElement | null =
    arrowsContainer.parentElement as HTMLElement;

  while (
    ancestor &&
    ancestor.className.indexOf(styles.clipEditorsContainer) < 0
  ) {
    if (ancestor.className.indexOf(styles.clipEditor) >= 0) {
      // found the editor - the result can be a negative number and that's OK
      return Math.round(
        (ancestor.clientWidth - arrowsContainer.clientWidth) / 2
      );
    }

    ancestor = ancestor.parentElement;
  }

  console.warn('Could not determine the centered position');

  return 0;
};

const ReorderingArrows = ({
  disableLeft,
  disableRight,
  onMoveLeft,
  onMoveRight,
}: Props): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);
  const [containerStyle, setContainerStyle] = useState<CSSProperties>({
    left: 0,
    visibility: 'hidden',
  });

  // this component is absolutely positioned and programmatically centered so
  // it does not distort the layout when the arrows are wider than the waveform container.
  useEffect(() => {
    // the arrows start hidden to prevent them flashing in the wrong position before being centered
    setContainerStyle({
      left: ref.current ? getLeftCenteredPosition(ref.current) : 0,
      visibility: 'initial',
    });
  }, []);

  return (
    <div ref={ref} className={styles.reorderingArrows} style={containerStyle}>
      <Align alignment="center" className="abc">
        <div className={styles.buttons}>
          <Arrange gap="xsmall">
            <IconButton
              id="reorderingArrowsLeft"
              altText={MOVE_LEFT_ALT_TEXT}
              size="small"
              isDisabled={disableLeft}
              icon={<SvgArrowLeftAlt />}
              onClick={onMoveLeft}
            />
            <IconButton
              id="reorderingArrowsRight"
              altText={MOVE_RIGHT_ALT_TEXT}
              size="small"
              isDisabled={disableRight}
              icon={<SvgArrowRightAlt />}
              onClick={onMoveRight}
            />
          </Arrange>
        </div>
      </Align>
    </div>
  );
};

export default ReorderingArrows;
